import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { usePersona, useUserInfo } from "@next-platform/client-common-core";
import { Spinner } from "@nextui-org/react";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { PageLayout, PageSize } from "@/components";
import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import { Col } from "@/components/customComponents";
import PersonaForm from "@/components/Personas/PersonaForm/PersonaForm";
import Trans from "@/components/Trans/Trans";
import { PERSONA_EDIT_NOT_FOUND_STATUS_CODE } from "@/constants/persona";

export default function PersonaEdit() {
  const { name } = useUserInfo();
  const { personas, getUserPersonaById } = usePersona();

  const { personaId } = useParams();

  const persona = getUserPersonaById(personaId || "");

  const metaProperties = useMemo(() => ({ personaName: name ?? undefined }), [name]);

  if (!personas.length) {
    return <Spinner className="absolute top-1/2 left-1/2 scale-[1.5]" />;
  }

  return (
    <PageLayout size={PageSize.Medium}>
      <PageStaticMetaTags
        pageId="editPersona"
        properties={metaProperties}
        prerenderStatusCode={!persona ? PERSONA_EDIT_NOT_FOUND_STATUS_CODE : undefined}
      />
      <Col className="bg-gray-3 rounded-lg p-md md:p-lg mt-4 md:mt-0">
        <Col className="grow gap-lg">
          <Col>
            <Text variant={TextVariants.HEADING_5_BOLD}>
              <Trans i18nKey="personas:page.editPersona.title" />
            </Text>
          </Col>
          <PersonaForm initialValues={persona ? persona : {}} edit={true} />
        </Col>
      </Col>
    </PageLayout>
  );
}
